export default "__VITE_ASSET__BYSp7fAH__"